import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import BusinessIcon from "@material-ui/icons/Business";
import { Collapse, Divider } from "@material-ui/core";
import DescriptionIcon from "@material-ui/icons/Description";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import FingerprintIcon from "@material-ui/icons/Fingerprint";
import FolderIcon from "@material-ui/icons/Folder";
import GroupIcon from "@material-ui/icons/Group";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { NavLink } from "react-router-dom";
import PanToolIcon from "@material-ui/icons/PanTool";
//import SettingsIcon from "@material-ui/icons/Settings";
import WorkIcon from "@material-ui/icons/Work";

import avatar from "../static/img/img_avatar.png";
import ImageProfile from "./common/imageProfile";
import { ROLES } from "../utils/constants";
import { PersonAdd } from "@material-ui/icons";
import SubjectIcon from "@material-ui/icons/Subject";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  navLink: {
    color: "inherit",
    textDecoration: "none",
  },
  listItemText: {
    fontSize: ".8rem",
  },
}));

export default function MenuList({ onOpen, selectedRole }) {
  const classes = useStyles();
  const [selectedIndex, setSelectedIndex] = useState("");
  const [open, setOpen] = useState(false);

  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
    onOpen();
  };

  const handleClick = (event, index) => {
    setSelectedIndex(index);
    setOpen(!open);
    onOpen();
  };

  return (
    <div className={classes.root}>
      <List component="nav" aria-label="main mailbox folders">
        <NavLink
          activeClassName="active"
          to="/mi/perfil"
          className={classes.navLink}
        >
          <ListItem style={{ display: "flex", justifyContent: "center" }}>
            <ImageProfile alt={"avatar"} location={avatar} size={"small"} />
          </ListItem>
        </NavLink>
        {selectedRole.name === ROLES.CIMOGSYS && (
          <>
            <NavLink
              activeClassName="active"
              to="/proyectos"
              className={classes.navLink}
            >
              <ListItem
                button
                selected={selectedIndex === 0}
                onClick={(event) => handleListItemClick(event, 0)}
              >
                <ListItemIcon>
                  <FolderIcon />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary={"Proyectos"}
                />
              </ListItem>
            </NavLink>

            <NavLink
              activeClassName="active"
              to="/grupos-investigacion"
              className={classes.navLink}
            >
              <ListItem
                button
                selected={selectedIndex === 1}
                onClick={(event) => handleListItemClick(event, 1)}
              >
                <ListItemIcon>
                  <WorkIcon />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary={"Grupos"}
                />
              </ListItem>
            </NavLink>

            <NavLink
              activeClassName="active"
              to="/investigadores"
              className={classes.navLink}
            >
              <ListItem
                button
                selected={selectedIndex === 2}
                onClick={(event) => handleListItemClick(event, 2)}
              >
                <ListItemIcon>
                  <GroupIcon />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary={"Investigadores"}
                />
              </ListItem>
            </NavLink>
            <Divider />

            <NavLink
              activeClassName="active"
              to="/dependencias"
              className={classes.navLink}
            >
              <ListItem
                button
                selected={selectedIndex === 3}
                onClick={(event) => handleListItemClick(event, 3)}
              >
                <ListItemIcon>
                  <BusinessIcon />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary={"Dependencias"}
                />
              </ListItem>
            </NavLink>

            <NavLink
              activeClassName="active"
              to="/lineas"
              className={classes.navLink}
            >
              <ListItem
                button
                selected={selectedIndex === 3}
                onClick={(event) => handleListItemClick(event, 3)}
              >
                <ListItemIcon>
                  <SubjectIcon />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary={"Lineas"}
                />
              </ListItem>
            </NavLink>

            <NavLink
              activeClassName="active"
              to="/usuarios"
              className={classes.navLink}
            >
              <ListItem
                button
                selected={selectedIndex === 4}
                onClick={(event) => handleListItemClick(event, 4)}
              >
                <ListItemIcon>
                  <PersonAdd />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary={"Usuarios"}
                />
              </ListItem>
            </NavLink>
            <NavLink
              activeClassName="active"
              to="/roles"
              className={classes.navLink}
            >
              <ListItem
                button
                selected={selectedIndex === 5}
                onClick={(event) => handleListItemClick(event, 5)}
              >
                <ListItemIcon>
                  <FingerprintIcon />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary={"Roles"}
                />
              </ListItem>
            </NavLink>
            <NavLink
              activeClassName="active"
              to="/permisos"
              className={classes.navLink}
            >
              <ListItem
                button
                selected={selectedIndex === 6}
                onClick={(event) => handleListItemClick(event, 6)}
              >
                <ListItemIcon>
                  <PanToolIcon />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary={"Permisos"}
                />
              </ListItem>
            </NavLink>
          </>
        )}

        {selectedRole.name === ROLES.ADMIN_GROUPS && (
          <>
            <NavLink
              activeClassName="active"
              to="/grupos-investigacion"
              className={classes.navLink}
            >
              <ListItem
                button
                selected={selectedIndex === 0}
                onClick={(event) => handleListItemClick(event, 0)}
              >
                <ListItemIcon>
                  <WorkIcon />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary={"Grupos"}
                />
              </ListItem>
            </NavLink>
            <NavLink
              activeClassName="active"
              to="/investigadores"
              className={classes.navLink}
            >
              <ListItem
                button
                selected={selectedIndex === 1}
                onClick={(event) => handleListItemClick(event, 1)}
              >
                <ListItemIcon>
                  <GroupIcon />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary={"Investigadores"}
                />
              </ListItem>
            </NavLink>
          </>
        )}
        {selectedRole.name === ROLES.ADMIN_PROJECTS && (
          <>
            <NavLink
              activeClassName="active"
              to="/proyectos"
              className={classes.navLink}
            >
              <ListItem
                button
                selected={selectedIndex === 0}
                onClick={(event) => handleListItemClick(event, 0)}
              >
                <ListItemIcon>
                  <FolderIcon />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary={"Proyectos"}
                />
              </ListItem>
            </NavLink>
            <NavLink
              activeClassName="active"
              to="/investigadores"
              className={classes.navLink}
            >
              <ListItem
                button
                selected={selectedIndex === 1}
                onClick={(event) => handleListItemClick(event, 1)}
              >
                <ListItemIcon>
                  <GroupIcon />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary={"Investigadores"}
                />
              </ListItem>
            </NavLink>
          </>
        )}
        {selectedRole.name === ROLES.INVESTIGADOR && (
          <>
            <NavLink
              activeClassName="active"
              to="/proyectosI"
              className={classes.navLink}
            >
              <ListItem
                button
                selected={selectedIndex === 0}
                onClick={(event) => handleListItemClick(event, 0)}
              >
                <ListItemIcon>
                  <FolderIcon />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary={"Proyectos"}
                />
              </ListItem>
            </NavLink>

            <ListItem
              button
              selected={selectedIndex === 1}
              onClick={(event) => handleClick(event, 1)}
            >
              <ListItemIcon>
                <DescriptionIcon />
              </ListItemIcon>
              <ListItemText
                classes={{ primary: classes.listItemText }}
                primary={"Informes"}
              />
              {open ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse
              in={open}
              timeout="auto"
              unmountOnExit
              style={{ marginLeft: "1em" }}
            >
              <List component="div" disablePadding>
                <NavLink
                  activeClassName="active"
                  to="/reporte/mensual"
                  className={classes.navLink}
                >
                  <ListItem
                    button
                    className={classes.nested}
                    selected={selectedIndex === 3}
                    onClick={(event) => handleListItemClick(event, 3)}
                  >
                    <ListItemText
                      classes={{ primary: classes.listItemText }}
                      primary="Elaboración de informes"
                    />
                  </ListItem>
                </NavLink>
                <NavLink
                  activeClassName="active"
                  to="/reporte/consulta"
                  className={classes.navLink}
                >
                  <ListItem
                    button
                    className={classes.nested}
                    selected={selectedIndex === 4}
                    onClick={(event) => handleListItemClick(event, 4)}
                  >
                    <ListItemText
                      classes={{ primary: classes.listItemText }}
                      primary="Consulta de informes"
                    />
                  </ListItem>
                </NavLink>
              </List>
            </Collapse>
          </>
        )}
        {selectedRole.name === ROLES.GUEST_GROUPS && (
          <>
            <NavLink
              activeClassName="active"
              to="/grupos-investigacionI"
              className={classes.navLink}
            >
              <ListItem
                button
                selected={selectedIndex === 1}
                onClick={(event) => handleListItemClick(event, 1)}
              >
                <ListItemIcon>
                  <WorkIcon />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary={"Grupos"}
                />
              </ListItem>
            </NavLink>
          </>
        )}
        {selectedRole.name === ROLES.GUEST_PROJECTS && (
          <>
            <NavLink
              activeClassName="active"
              to="/proyectosI"
              className={classes.navLink}
            >
              <ListItem
                button
                selected={selectedIndex === 0}
                onClick={(event) => handleListItemClick(event, 0)}
              >
                <ListItemIcon>
                  <FolderIcon />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary={"Proyectos"}
                />
              </ListItem>
            </NavLink>
          </>
        )}
      </List>
    </div>
  );
}
